import GanttButton from "./GanttButton";
import ListButton from "./ListButton";
import React from "react";
import styled from "styled-components";

const ToggleGanttListButton = ({listView, toggleGantView, toggleListView, ganttView}) => {
    return (
        <ViewsContainer>
            <GanttButton isSelected={ganttView} handleOpen={toggleGantView}/>
            <ListButton isSelected={listView} handleOpen={toggleListView}/>
        </ViewsContainer>
    )
}


const ViewsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  margin-bottom: 1rem;
`

export default ToggleGanttListButton